import axiosConfig from './axiosConfig'

export const getTeamInfo = () => axiosConfig.get('/web/api/teamInfo/list')

export const searchDriverInfo = (callNumber, teamId) =>
  axiosConfig.get(
    `/web/api/searchfavoritedriver/?callNumber=${callNumber}&teamId=${teamId}`
  )
